import React, { FunctionComponent, ReactNode } from 'react'
import styles from './style.module.css'
import { useDesignLanguagePerClass } from '@afterpaytouch/core'

export interface FormWrapperProps {
  children: ReactNode
}

export const FormWrapper: FunctionComponent<FormWrapperProps> = ({ children }) => {
  const designLanguageStyles = useDesignLanguagePerClass(styles)

  return <div className={designLanguageStyles.formWrapper}>{children}</div>
}
